import { consoleEvents, LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import { NewsState } from './types'

const fetchNewsStart = (state: NewsState): NewsState => ({
  ...state,
  newsLoadingState: LoadingStates.Loading,
})

const fetchNewsSuccess = (state: NewsState, news: NewsState['news']): NewsState => ({
  ...state,
  news: [...state.news, ...news],
  newsLoadingState: LoadingStates.LoadedSuccess,
  isNewsPopulated: true,
})

const fetchNewsFail = (state: NewsState, error: Error): NewsState => {
  consoleEvents.error('Failed to fetch news', error)
  return {
    ...state,
    newsLoadingState: LoadingStates.LoadedFail,
    isNewsPopulated: false,
  }
}

const reducer = createReducer((on) => {
  on(actions.fetchNewsStart, fetchNewsStart)
  on(actions.fetchNewsSuccess, fetchNewsSuccess)
  on(actions.fetchNewsFail, fetchNewsFail)
}, initialState)

export default reducer
